export const integrations = [
  // {
  //   id: "rapidlearningcycles",
  //   logo: "rapidlearningcycles",
  //   name: "Rapid Learning Cycles",
  //   description: (
  //     <>
  //       En metode til hurtig læring og sikre beslutninger i projekter.
  //       Kortlægger nøglebeslutninger, videnhuller og aktiviteter, så teams kan
  //       skabe klarhed tidligt og undgå dyre omveje.
  //     </>
  //   ),
  //   disabled: false,
  // },
  // {
  //   id: "microsoft365",
  //   logo: "microsoft365",
  //   name: "Microsoft 365",
  //   description: (
  //     <>
  //       Integrer Microsoft 365 for at få adgang til e-mails,
  //       kalenderbegivenheder og dokumenter direkte i FocusMap. Giver et samlet
  //       overblik over din arbejdsdag.
  //     </>
  //   ),
  //   disabled: true,
  // },
  // {
  //   id: "onenote",
  //   logo: "logo",
  //   name: "OneNote",
  //   description: (
  //     <>
  //       Integrer OneNote for at få adgang til dine noter direkte i FocusMap.
  //       Giver dig mulighed for at organisere og visualisere dine tanker og idéer
  //       effektivt.
  //     </>
  //   ),
  //   disabled: true,
  // },
  // {
  //   id: "sustainability",
  //   logo: "sustainability",
  //   name: "Bæredygtighedshjulet",
  //   description: (
  //     <>
  //       Bæredygtighedshjulet giver overblik og hjælper jer med at måle på og
  //       arbejde struktureret med bæredygtighed i virksomheden på 20 fokusområder
  //       – baseret på Erhvervshusenes model af samme navn.
  //     </>
  //   ),
  //   disabled: true,
  // },
  // {
  //   id: "bonsai",
  //   logo: "bonsai",
  //   name: "BONSAI Climate Footprint Analyser",
  //   description: (
  //     <>
  //       En visuel overbygning af åben database udviklet af Aalborg Universitet
  //       til analyse af klimaaftryk på tværs af produkter og aktiviteter. Gør
  //       bæredygtige valg mulige baseret på livscyklusdata og CO₂-udledning.
  //     </>
  //   ),
  //   disabled: true,
  // },
  // {
  //   id: "lawyer",
  //   logo: "advokatsamfundet",
  //   name: "Advokatmodul",
  //   description: (
  //     <>
  //       Et arbejdsredskab til at styrke sagsopbygning, skabe og visualisere
  //       datarelationer samt forankre tidslinjer og overblik i komplekse sager.
  //     </>
  //   ),
  //   disabled: true,
  // },
];
